import client from './client';

export const listCodingChallenges = () => client.get('/api/coding-challenges');

export const createCodingChallenge = (data) => client.post('/api/coding-challenges', data);

export const deleteCodingChallenge = (id) => client.delete(`/api/coding-challenges/${id}`);

export const getRandomCodingChallenge = (sessionId, token) =>
  client.get(`/api/coding-challenges/random/${sessionId}`, { params: { token } });

export const submitCodingSolution = (sessionId, body) =>
  client.post(`/api/sessions/${sessionId}/coding/submit`, body);

export const getCodingSubmission = (sessionId) =>
  client.get(`/api/sessions/${sessionId}/coding/submission`);
